var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuNewsletter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "50px",
    height: "50px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#121926",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,1c-1.09306,0 -2,0.90694 -2,2h-8c-1.64545,0 -3,1.35455 -3,3v39c0,1.64545 1.35455,3 3,3h32c1.64545,0 3,-1.35455 3,-3v-39c0,-1.64545 -1.35455,-3 -3,-3h-8c0,-1.09306 -0.90694,-2 -2,-2zM19,3h12v5h-12zM9,5h8v2h-7v37h30v-37h-7v-2h8c0.55454,0 1,0.44545 1,1v39c0,0.55454 -0.44546,1 -1,1h-32c-0.55455,0 -1,-0.44546 -1,-1v-39c0,-0.55455 0.44545,-1 1,-1zM12,9h5.28125c0.34965,0.59274 0.98993,1 1.71875,1h12c0.72882,0 1.3691,-0.40726 1.71875,-1h5.28125v33h-26zM16,13v2h18v-2zM16,18v2h18v-2zM16,23v2h8v-2zM34,28c-1.105,0 -2,0.895 -2,2c0,0.23187 0.04665,0.45116 0.11914,0.6582l-3.75391,4.37891c-0.11897,-0.02204 -0.23985,-0.03711 -0.36523,-0.03711c-0.17818,0 -0.34733,0.03055 -0.51172,0.07422l-3.5625,-3.5625c0.04367,-0.16439 0.07422,-0.33354 0.07422,-0.51172c0,-1.105 -0.895,-2 -2,-2c-1.105,0 -2,0.895 -2,2c0,0.17818 0.03055,0.34733 0.07422,0.51172l-3.5625,3.5625c-0.16439,-0.04367 -0.33354,-0.07422 -0.51172,-0.07422c-1.105,0 -2,0.895 -2,2c0,1.105 0.895,2 2,2c1.105,0 2,-0.895 2,-2c0,-0.17818 -0.03055,-0.34733 -0.07422,-0.51172l3.5625,-3.5625c0.16439,0.04367 0.33354,0.07422 0.51172,0.07422c0.17818,0 0.34733,-0.03055 0.51172,-0.07422l3.5625,3.5625c-0.04367,0.16439 -0.07422,0.33354 -0.07422,0.51172c0,1.105 0.895,2 2,2c1.105,0 2,-0.895 2,-2c0,-0.23187 -0.04665,-0.45116 -0.11914,-0.6582l3.75391,-4.37891c0.11897,0.02205 0.23985,0.03711 0.36523,0.03711c1.105,0 2,-0.895 2,-2c0,-1.105 -0.895,-2 -2,-2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuNewsletter);
export default __webpack_public_path__ + "static/media/icon-menu-newsletter.1f5319f5fa7ff9d7f26e6d660d2d8edc.svg";
export { ForwardRef as ReactComponent };